import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/subject/subjects/editSubjectContainer';
import { actions } from '../../../redux/subject/subjects';

export default function () {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
